<template>
    <div class="w-full" style="max-width: 700px;">
        <p class="xl:text-lg lg:text-md md:text-normal line-height-2">
            Согласно этому руководству проходят операции или переводы (трансферы) между клиентами и мерчантами сервиса
            PayWave. Мерчант – это лицо принимающее средства кл (мерчант приема) или отправляющие средства клиентов
            (мерчант отправки).
        </p>

        <h3 class="text-xl font-medium mt-4">
            Условия работы:
        </h3>
        <ul class="xl:text-lg lg:text-md md:text-normal line-height-2">
            <li class="mb-2">
                Для того, чтобы стать мерчантом - требуется пройти регистрацию на сайте как клиент, затем привязать свой
                Telegram для получения уведомлений, согласиться с условиями работы и пройти регистрацию мерчанта.</li>
            <li class="mb-2">
                Для того, чтобы быть мерчантом приема – требуется внести депозит на внутренний счет сервиса в USDT от
                100$ и добавить карты или счета приема в личном кабинете мерчанта.</li>
            <li class="mb-2">
                Для того, чтобы быть мерчантом отправки – требуется добавить способы отправки (банки отправки) в личном
                кабинете мерчанта и указать ваши резервы в валюте. Если вы имеете на счетах, например 100 000 рублей и
                готовы их выплатить, вы должны указать в резервах 100 000 рублей.</li>
        </ul>

        <h3 class="text-xl font-medium mt-4">
            Схема работы и взаиморасчетов:
        </h3>
        <ul class="xl:text-lg lg:text-md md:text-normal line-height-2">
            <li class="mb-2">
                При создании перевода Клиентом сервиса, например из рублей в рупии, алгоритмом выбора мерчантов
                определяется мерчант приема и мерчант отправки. Схему работы алгоритма выбора уточните у администратора.
                В переводе указаны все данные для перевода: суммы приема и отправки в валюте, сумма комиссий и размера
                перевода, размеры комиссий, данные получателя и отправителя и другие данные.</li>
            <li class="mb-2">
                Клиент после подтверждения оплаты должен приложить чек об операции из банка, который подгрузится в
                личном кабинете мерчанта приема и придет ему в уведомлении в чат-бот.</li>
            <li class="mb-2">
                Мерчант приема (и отправки) получает уведомление о том, что на его счет или карту должны поступить
                средства от клиента. Затем, как правило, в течение 15 минут приходит либо подтверждение Отправителя об
                оплате, либо отмена перевода.</li>
            <li class="mb-2">
                При создании перевода средства мерчанта замораживаются на сумму перевода и сумму комиссий на счете
                заморозки до тех пор, пока перевод не будет закрыт или выполнен.</li>
            <li class="mb-2">
                Если средства поступили в полном объеме – мерчанту приема нужно отметить на странице перевода, что
                перевод принят нажав кнопку “Принять перевод”.</li>
            <li class="mb-2">
                Далее мерчант отправки получает уведомление о том, что мерчант приема принял перевод и далее мерчанту
                отправки требуется выплатить нужную сумму в нужной валюте на реквизиты клиента. И нажать кнопку “Перевод
                отправлен”. И прикрепить чек на сайте или в чат-боте. Чек подгрузится в кабинете у клиента.</li>
            <li class="mb-2">
                В случае, если мерчант приема и отправки - один и тот же, то нужно нажать кнопку один раз.</li>
            <li class="mb-2">
                Далее клиент получает уведомление о том, что средства поступили на его реквизиты и требуется отметить
                перевод как выполненный. Клиент видит чек в личном кабинете и подтверждает получение перевода.</li>
            <li class="mb-2">
                Затем комиссии зачисляются обоим мерчантам, а сумма (тело) перевода со счета заморозки переводится на
                счет мерчанта отправки.</li>
        </ul>

        <h3 class="text-xl font-medium mt-4">
            Обязанности:
        </h3>
        <ul class="xl:text-lg lg:text-md md:text-normal line-height-2">
            <li class="mb-2">Если от клиента поступили средства меньше или больше суммы перевода, то мерчант обязан связаться с
                администратором. И далее, в зависимости от решения администратора - либо вернуть средства на реквизиты
                клиента частично или полностью, либо дождаться нового перевода с верной суммой.</li>
            <li class="mb-2">Если на мерчанта пришел перевод, но мерчант был не “в сети” или не отвечал на входящие сообщения или
                звонки старшего менеджера более 1 часа – менеджер в праве подтвердить перевод за вас в случае Приема
                средств. А в случае с отправкой старший менеджер может перевести перевод на другого мерчанта отправки.
            </li>
            <li class="mb-2">При поступлении средств на карты или счета мерчанта, даже при условии, что не было входящего перевода,
                мерчант обязан предупредить об этом администратора.</li>
            <li class="mb-2">В случае, если перевод закрылся, но средства поступили на карту или счета мерчанта - мерчант обязан
                уведомить об этом администратора.</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'MerchantRules'
};
</script>